module.exports = __webpack_public_path__ + "static/img/10kwadrat2D.d149d312.png";